import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const LoadingScreen = ({ message = 'Loading...', fullScreen = true }) => {
  const containerClass = fullScreen 
    ? 'fixed inset-0 flex items-center justify-center bg-white z-50'
    : 'flex items-center justify-center py-8';

  return (
    <div className={containerClass}>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        className="flex flex-col items-center space-y-4"
      >
        {/* Solar Animation */}
        <div className="relative">
          <div className="solar-rays">
            <CircularProgress
              size={60}
              thickness={4}
              sx={{
                color: '#FF6B35',
                '& .MuiCircularProgress-circle': {
                  strokeLinecap: 'round',
                },
              }}
            />
          </div>
          
          {/* Sun Icon in Center */}
          <div className="absolute inset-0 flex items-center justify-center">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-orange-500"
            >
              <circle cx="12" cy="12" r="5" fill="currentColor" />
              <path
                d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        {/* Loading Text */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <Typography
            variant="h6"
            color="text.secondary"
            className="font-medium"
          >
            {message}
          </Typography>
        </motion.div>

        {/* TLC Branding */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-center"
        >
          <Typography
            variant="body2"
            color="text.secondary"
            className="mb-1"
          >
            TLC Solar Marketplace
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            className="opacity-75"
          >
            Powering Communities with Clean Energy
          </Typography>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default LoadingScreen;